import { findModuleInMenu } from "../../helpers/Utils"
export default (context) => {
  const M = "admUser."
  const itemAdmAudit = {
    id: 1,
    icon: 'simple-icon-check',
    name: `${M}auditHistory`,
    onClick: (row, ctx) => {
      const index = ctx.view.extras.itemsInRowsTable.findIndex(f => f.id === 1)
      ctx.view.extras.itemsInRowsTable[index].form.name = `Historial / Auditoria: ${row.name}`
    },
    form: {
      name: 'Historial / Auditoría',
      detailGrid: () => {
        return {
          module: 'admAudit',
          parentIdField: null,
          filterBy: () => { return {userId: context.state.idItemPreSelected} }
        }
      },
      okMsg: 'Ok',
      fields: [],
      onSuccess: (r) => { },
      onError: (e) => { }
    }
  }
  let itemsInRowsTable = []
  const admAudit = findModuleInMenu(context.props.menuItems, "id", "admAudit")
  if (admAudit) itemsInRowsTable.push(itemAdmAudit)

  let filter = {
    fields: [
      {
        name: "type",
        value: 0,
        type: "select",
        label: "main.userType",
        opts: {
          style: 'float-label',
          items: [
            { value: 0, label: "main.all" },
            { value: 1, label: `${M}parents` },
            { value: 2, label: `${M}nonParents` },
            { value: 3, label: `${M}dependants` },
            { value: 4, label: `${M}externals` },
          ]
        }
      },
      {
        name: "active",
        value: 0,
        type: "select",
        label: "main.activity",
        opts: {
          style: 'float-label',
          items: [
            { value: 0, label: "main.all" },
            { value: 1, label: `${M}activeLastWeek` },
            { value: 3, label: `${M}activeInBrowser` },
            { value: 2, label: `${M}activeInApp` },
            { value: 5, label: `${M}activeInWhatsApp` },
            { value: 4, label: `${M}dormant` },
          ]
        },
        renderIf: (ctx) => { return Number.isInteger(ctx.state.type) }
      }
    ],
    buttons: [
      {
        label: 'main.applyFilter',
        onClick: ctx => ctx.btnAction('filter'),
        renderIf: ctx => Number.isInteger(ctx.state.type) || Number.isInteger(ctx.state.active)
      }
    ]
  }

  let columns = [
    {
      Header: "",
      accessor: "img",
      type: "img"
    },
    {
      Header: "main.ID",
      accessor: "ID"
    },
    {
      Header: "main.name",
      accessor: "name"
    },
    {
      Header: "main.lastName",
      accessor: "last"  
    },
    {
      Header: "main.lastAccess",
      accessor: "lastSeen",
      isDate: true
    },
    {
      Header: "main.externalId",
      accessor: "externalId"
    }
  ]

  const moduleConfig = {
    config: {
      pageSize: 40,
      list: false,
      remapRow: (form, res, action, resUpload) => {
        form.img = form.face
        form.name = `${form.last} ${form.last2?? ''}, ${form.name}`
        if (resUpload?.url) form.img = `${resUpload.url}?date=${Date.now()}`
        return form
      }
    },

    actions: {
      create: false,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: {
        by: "search"
      },
      import: {
        templateFile: "UsersImport.xlsx"
      }
    },

    extras: {
      itemsInRowsTable: itemsInRowsTable
    },

    filter: filter,

    form: {
      fields: [
        {
          col: 12,
          name: "face",
          value: "",
          type: "dropzone",
          label: "main.photography",
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "admUser/file",
            accept: '.jpeg,.jpg,.png'
          }
        },
        {
          col: 6,
          name: "name",
          value: null,
          type: "text",
          label: "main.name",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "last",
          value: null,
          type: "text",
          label: "main.lastName",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "mail",
          value: null,
          type: "text",
          label: "main.email",
          rules: 'required|email',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "cel",
          value: null,
          type: "number",
          label: "main.cellPhone",
          rules: "max:13",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "gender",
          value: null,
          type: "select",
          label: "main.gender",
          opts: {
            style: 'float-label',
            items: [
              { value: 'M', label: 'M'},
              { value: 'F', label: 'F'}
            ]
          }
        },
        {
          col: 6,
          name: "doc",
          value: null,
          type: "text",
          label: "main.identityDocument",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "notifModes",
          value: null,
          type: "text",
          label: "main.notifyVia",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "externalId",
          value: null,
          type: "text",
          label: "main.externalId",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "userKind",
          value: null,
          type: "select",
          label: "main.userType",
          opts: {
            style: 'float-label',
            items: [
              { value: 0, label: 'Titular / Padre de familia' },
              { value: 3, label: 'Externo / invitado' }
            ]
          }
        },
        {
          col: 6,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive",
          opts: {
            style: 'float-label'
          }
        }
      ]
    },

    columns: columns
  }
  return moduleConfig
}